module Client.Components.SupplyCategories

open Client
open Client.Services
open Shared
open global.Elmish
open Fable.Core.JsInterop
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.SweetAlert
open Feliz.UseElmish
open Fable.Core.Experimental
open Fable.Core.JS
open CustomerDexImaging.Models

let strOption (s : string) = if String.IsNullOrWhiteSpace s then None else Some s

type SupplyCategorySelectionState =
  { SupplyCategory : SupplyCategory; Selected : bool; IsOtherCategory : bool; }

// let toSortOrder (x : SupplyCategory) =
//     match x with
//     | SupplyCategory.
type Model =
  { SelectionState : SupplyCategorySelectionState list
    ShowOtherCategories : bool } with
    static member init availableSelections initialSelections otherSelections =
      let otherSupplyCategories = otherSelections |> List.except availableSelections;
      let initialSelectionState =
        [ availableSelections |> List.map (fun x -> { Selected = initialSelections |> List.contains x; SupplyCategory = x; IsOtherCategory = false; })
          otherSupplyCategories |> List.map (fun x -> { Selected = false; SupplyCategory = x; IsOtherCategory = true; }) ]
        |> List.concat
      { SelectionState = initialSelectionState
        ShowOtherCategories = false }

let useLoadingStyles =
  Styles.makeStyles(fun styles theme ->
    {|
      root = styles.create [
        Feliz.style.height 20
        Feliz.style.backgroundColor theme.palette.grey.``200``
        Feliz.style.borderRadius 10
      ]
      blackBar = styles.create [
        Feliz.style.backgroundColor "black"
      ]
      cyanBar = styles.create [
        Feliz.style.backgroundColor "cyan"
      ]
      magentaBar = styles.create [
        Feliz.style.backgroundColor "magenta"
      ]
      yellowBar = styles.create [
        Feliz.style.backgroundColor "yellow"
      ]
    |}
  )

type Colors = | Black | Cyan | Yellow | Magenta
let viewLevel = React.functionComponent (fun (inputProps: {| color : Colors; level : int option; |}) ->
  let classes = useLoadingStyles()
  let t = inputProps.level |> Option.map (fun x -> sprintf "%i%%" x) |> Option.defaultValue ""
  let barColor =
    match inputProps.color with
    | Black -> classes.blackBar
    | Cyan -> classes.cyanBar
    | Yellow -> classes.yellowBar
    | Magenta -> classes.magentaBar
  match inputProps.level with
  | None -> Html.text t
  | Some 0 -> Html.text ""
  | Some l ->
    Mui.tooltip [
      tooltip.title t
      tooltip.children
        (
          Mui.linearProgress [
            linearProgress.classes.root classes.root
            linearProgress.value l
            linearProgress.variant.determinate
            linearProgress.classes.barColorPrimary barColor
          ]
        )
    ]
)

let view = React.functionComponent (fun (inputProps: {| initialSelections : SupplyCategory list; availableSelections : SupplyCategory list; otherSelections : SupplyCategory list; mpsScanOption : MpsScan option; disableInput : bool; returnResult: SupplyCategory list -> unit; |}) ->
  let state, setState = React.useState(Model.init inputProps.availableSelections inputProps.initialSelections inputProps.otherSelections)
  Html.div [
    Mui.grid [
      grid.container true
      grid.direction.column
      grid.spacing._2
      grid.children [
        Mui.grid [
          grid.item true
          grid.children [
            let selectedCount = state.SelectionState |> List.filter (fun x -> x.Selected) |> List.length
            let t =
              match inputProps.availableSelections.Length, selectedCount with
              | 1,1 -> "A supply category has been selected for you."
              | 1,_ -> "Please select a supply category."
              | _ -> "Please select one or more supply categories."
            Html.text t
          ]
        ]
      ]
    ]

    let handleSelectionChange s =
      let newSelectionState = state.SelectionState |> List.map (fun x -> if x.SupplyCategory = s.SupplyCategory then { x with Selected = not x.Selected } else x )
      setState { state with SelectionState = newSelectionState }
      newSelectionState |> List.choose (fun x -> if x.Selected then Some x.SupplyCategory else None) |> inputProps.returnResult

    let categoriesToDisplay =
      if state.ShowOtherCategories
      then state.SelectionState
      else state.SelectionState |> List.filter (fun x -> not x.IsOtherCategory)

    Mui.grid [
      grid.container true
      grid.direction.column
      grid.spacing._0
      grid.children [
        Mui.grid [
          grid.item true
          grid.md._6
          grid.lg._3
          grid.children [
            Mui.grid [
              grid.container true
              grid.direction.row
              //grid.justifyContent.flexStart
              grid.alignItems.center
              grid.alignContent.spaceBetween
              grid.spacing._2
              grid.children [
                Mui.grid [
                  grid.item true
                  grid.xs._6
                  grid.children [
                    Mui.typography [
                      typography.variant.h6
                      typography.children "Category"
                    ]
                  ]
                ]
                match inputProps.mpsScanOption with
                | Some _ ->
                  Mui.grid [
                    grid.item true
                    grid.xs._3
                    grid.children [
                      Mui.typography [
                        typography.variant.h6
                        typography.children "Supply level"
                      ]
                    ]
                  ]
                | None -> ()
                match inputProps.mpsScanOption with
                | Some mpsScan ->
                  match mpsScan.Date with
                  | Some _ ->
                    Mui.grid [
                      grid.item true
                      grid.xs._2
                      grid.children [
                        Mui.typography [
                          typography.variant.h6
                          typography.children "Scan date"
                        ]
                      ]
                    ]
                  | None -> ()
                | None -> ()
              ]
            ]
          ]
        ]
        for s in categoriesToDisplay do
          Mui.grid [
            grid.item true
            grid.md._6
            grid.lg._3
            grid.children [
              Mui.grid [
                grid.container true
                grid.direction.row
                //grid.justifyContent.flexStart
                grid.alignItems.center
                grid.alignContent.spaceBetween
                grid.spacing._2
                grid.children [
                  Mui.grid [
                    grid.item true
                    grid.xs._6
                    grid.children [
                      Mui.formControlLabel [
                        formControlLabel.control (
                          Mui.checkbox [
                          checkbox.checked' s.Selected
                          checkbox.disabled inputProps.disableInput
                          checkbox.onChange (fun (b : bool) -> handleSelectionChange s )
                          prop.name (s.SupplyCategory.toString)
                          ]
                        )
                        formControlLabel.label (
                          Mui.typography [
                            typography.variant.body1
                            typography.children s.SupplyCategory.toString
                          ]
                        )
                      ]
                    ]
                  ]
                  match inputProps.mpsScanOption with
                  | Some level ->
                    match s.SupplyCategory with
                    | SupplyCategory.Black ->
                      Mui.grid [
                        grid.item true
                        grid.xs._3
                        grid.children [
                          viewLevel {| color = Colors.Black; level = level.Black; |}
                        ]
                      ]
                    | SupplyCategory.Cyan ->
                      Mui.grid [
                        grid.item true
                        grid.xs._3
                        grid.children [
                          viewLevel {| color = Colors.Cyan; level = level.Cyan; |}
                        ]
                      ]
                    | SupplyCategory.Magenta ->
                      Mui.grid [
                        grid.item true
                        grid.xs._3
                        grid.children [
                          viewLevel {| color = Colors.Magenta; level = level.Magenta; |}
                        ]
                      ]
                    | SupplyCategory.Yellow ->
                      Mui.grid [
                        grid.item true
                        grid.xs._3
                        grid.children [
                          viewLevel {| color = Colors.Yellow; level = level.Yellow; |}
                        ]
                      ]
                    | _ -> ()
                  | None -> ()

                  match inputProps.mpsScanOption with
                  | Some mpsScan ->
                    match s.SupplyCategory with
                    | SupplyCategory.Black
                    | SupplyCategory.Cyan
                    | SupplyCategory.Magenta
                    | SupplyCategory.Yellow ->
                      match mpsScan.Date with
                      | Some d ->
                        Mui.grid [
                          grid.item true
                          grid.xs._2
                          grid.children [
                            Mui.typography [
                              typography.variant.body1
                              typography.children (d.ToShortDateString())
                            ]
                          ]
                        ]
                      | None -> ()
                    | _ -> ()
                  | None -> ()
                ]
              ]
            ]
          ]

        if not state.ShowOtherCategories && state.SelectionState |> List.exists (fun x -> x.IsOtherCategory) then
          Mui.grid [
            grid.item true
            grid.md._6
            grid.lg._3
            grid.children [
              Mui.grid [
                grid.container true
                grid.direction.row
                grid.alignItems.center
                grid.alignContent.spaceBetween
                grid.spacing._2
                grid.children [
                  Mui.grid [
                    grid.item true
                    grid.xs._6
                    grid.children [
                      Mui.formControlLabel [
                        formControlLabel.control (
                          Mui.checkbox [
                            checkbox.checked' state.ShowOtherCategories
                            checkbox.disabled inputProps.disableInput
                            checkbox.onChange (fun (b : bool) -> setState { state with ShowOtherCategories = not state.ShowOtherCategories })
                            prop.name "Other"
                          ]
                        )
                        formControlLabel.label "Other"
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]

      ]
    ]

    if state.SelectionState |> List.exists (fun x -> x.Selected) |> not
    then Mui.formHelperText "Please select at least one supply category."
    else ()

  ]
)